export const endpointByEnv = {
    test: 'ws://localhost:4000',
    local: 'ws://localhost:4000',
    development: 'wss://converse-rtm-api.development.dev.woltapi.com',
    production: 'wss://converse-rtm-api.wolt.com',
};
//# sourceMappingURL=constants.js.map